import { render, staticRenderFns } from "./vehicleDisassemblyWaste.vue?vue&type=template&id=40109bec&scoped=true"
import script from "./vehicleDisassemblyWaste.vue?vue&type=script&lang=js"
export * from "./vehicleDisassemblyWaste.vue?vue&type=script&lang=js"
import style0 from "./vehicleDisassemblyWaste.vue?vue&type=style&index=0&id=40109bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40109bec",
  null
  
)

export default component.exports